import { decrypt } from "../functions/mobile";
import { osName, osVersion } from "react-device-detect";
import { getDeviceIp } from "../functions/core-actions";


export const getDeviceInfo = async (user) => {
  // esto se consume para llenar el device
  try {
    const ip = await getDeviceIp()
    const { caja_app }  = localStorage
    if (caja_app !== undefined) {
      const { v, iv, key_name, key_value, cipher } = localStorage
      const dataDevice = decrypt(JSON.stringify({v, iv, keys: {[key_name]: key_value}, cipher}))
      if (dataDevice === undefined) {
        // se intento insertar data  falsa, no se pudo desencriptar
        const device =  `${osName} ${osVersion}`
        return {
          data: { ip, device, mac: 'NAVEGADOR', user  },
          info: {aditional: 'posible intento de insertar informacion de dispositivo'}
        }
      } else {
          // const { device, device_version, ipDevice, mac } = JSON.parse(dataDevice)
           const { device, device_version, mac } = JSON.parse(dataDevice)
          return {
            data: { ip, device: `${device} (${device_version})`, user, mac },
            info: {}
          }
      }
    } else {
      const device =  `${osName} ${osVersion}`
      return {
        data: { ip, device, user, mac: 'NAVEGADOR'  },
        info: {}
      }
    }
  } catch (error) {
    //console.log(error)
    return { data: {}}
  }
}